module.exports = __webpack_public_path__ + "img/PAD.df516f53.svg";